import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import {
    manualCashLimitsType,
    sortingParamType,
} from '../../types';
import ManualCashLimitRow from './ManualCashLimitRow';
import SortControl from '../SortControl';

ManualCashLimitsList.propTypes = {
    manualCashLimits: manualCashLimitsType.isRequired,
    onSort: PropTypes.func.isRequired,
    sortingParam: sortingParamType.isRequired,
};

function ManualCashLimitsList(props) {
    const {
        manualCashLimits,
        onSort,
        sortingParam,
    } = props;
    const { t } = useTranslation();
    return (
        <div className="manual-cash-limits-list">
            <div className="rich-list-row rich-list-header manual-cash-limits-list--header">
                <div className="rich-list-row--arrow-mobile" />
                <div className="manual-cash-limit-header--values--member">
                    <SortControl onChange={onSort} sortingParam={sortingParam} sortingKey="member.memberId">
                        {t('manual-cash-limits.list-header.member')}
                    </SortControl>
                </div>
                <div className="manual-cash-limit-header--values--limit-value">
                    <SortControl onChange={onSort} sortingParam={sortingParam} sortingKey="limitValue">
                        {t('manual-cash-limits.list-header.limit-value')}
                    </SortControl>
                </div>
                <div className="manual-cash-limit-header--values--begin-date">
                    <SortControl onChange={onSort} sortingParam={sortingParam} sortingKey="beginDate">
                        {t('manual-cash-limits.list-header.begin-date')}
                    </SortControl>
                </div>
                <div className="manual-cash-limit-header--values--end-date">
                    <SortControl onChange={onSort} sortingParam={sortingParam} sortingKey="endDate">
                        {t('manual-cash-limits.list-header.end-date')}
                    </SortControl>
                </div>
                <div className="manual-cash-limit-header--values--currency">
                    <SortControl onChange={onSort} sortingParam={sortingParam} sortingKey="limitCurrency.code">
                        {t('manual-cash-limits.list-header.currency')}
                    </SortControl>
                </div>
                <div className="manual-cash-limit-header--values--clearing-house">
                    <SortControl onChange={onSort} sortingParam={sortingParam} sortingKey="clearingHouse.code">
                        {t('manual-cash-limits.list-header.clearing-house')}
                    </SortControl>
                </div>
                <div className="rich-list-row--arrow" />
            </div>
            {
                manualCashLimits.length
                    ? manualCashLimits.map((manualCashLimit) => (
                        <ManualCashLimitRow
                            manualCashLimit={manualCashLimit}
                            key={manualCashLimit.id}
                        />
                    ))
                    : (
                        <div className="manual-cash-limits-no-items">
                            {t('manual-cash-limits.no-items')}
                        </div>
                    )
            }
        </div>
    );
}

export default ManualCashLimitsList;
